import React from 'react';
import { BsFormControl, BsModalForm } from '../../collection/bootstrap/BootstrapComponents';
import { apiForm, apiGet } from '../../utils/api';

export default function VacacionesComentarioResponsableModal(props) {
    const updateData = async () => await apiGet("vacaciones/get/" + props.idVacaciones);

    const checkData = formData => {
        let errors = {};
        return errors;
    }

    const saveData = async data => {
        const result = await apiForm("vacaciones/comment", data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle="Comentar vacaciones"
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            <VacacionesComentarioResponsableForm />
        </BsModalForm>
    );
}

function VacacionesComentarioResponsableForm(props) {
    const data = props.data;
    const errors = props.errors;
    return <>
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentarioResponsable"
            value={data.comentarioResponsable} error={errors.comentarioResponsable}
            className="mt-3" maxLength="250" as="textarea" />
    </>;
}
